import React, { useState, useEffect } from 'react';
import api from '../../api/axiosConfig';
import { PlusCircle, Trash2, Edit3 } from 'lucide-react';

// --- Helper function để lấy token ---
const getAuthToken = (): string | null => {
    const userString = sessionStorage.getItem('user'); // ✅ SỬA Ở ĐÂY
    if (userString) {
        try {
            return JSON.parse(userString).accessToken || null;
        } catch (e) {
            console.error("Lỗi đọc user data:", e);
            return null;
        }
    }
    return null;
};


// --- Modal tạo sê-ri mới ---
const GenerateSerialsModal = ({
  onClose,
  onGenerated,
}: {
  onClose: () => void;
  onGenerated: () => void;
}) => {
  const [manualSerials, setManualSerials] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [devices, setDevices] = useState<any[]>([]);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const token = getAuthToken(); // ✅ Dùng helper
        const { data } = await api.get('/devices', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDevices(data);
      } catch (err) {
        console.error('❌ Lỗi khi tải danh sách thiết bị:', err);
      }
    };
    fetchDevices();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const serialNumbers = manualSerials
      .split('\n')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    if (!deviceId) {
      window.alert('⚠️ Vui lòng chọn thiết bị!');
      return;
    }

    if (serialNumbers.length === 0) {
      window.alert('⚠️ Vui lòng nhập ít nhất một mã sê-ri!');
      return;
    }

    try {
      const token = getAuthToken(); // ✅ Dùng helper
      await api.post(
        '/serials/generate',
        { deviceId, serialNumbers },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      window.alert('✅ Tạo mã sê-ri thành công!');
      onGenerated();
      onClose();
    } catch (error: any) {
      window.alert(error.response?.data?.message || '❌ Tạo mã sê-ri thất bại.');
    }
  };

  // ... (JSX của modal không đổi)
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Tạo mã Sê-ri</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Chọn thiết bị</label>
            <select
              value={deviceId}
              onChange={(e) => setDeviceId(e.target.value)}
              required
              className="w-full border p-2 rounded"
            >
              <option value="">-- Chọn thiết bị --</option>
              {devices.map((d) => (
                <option key={d._id} value={d._id}>
                  {d.name_vi}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nhập các mã sê-ri (mỗi dòng một mã)
            </label>
            <textarea
              value={manualSerials}
              onChange={(e) => setManualSerials(e.target.value)}
              rows={8}
              placeholder={`VD:\nABC123\nXYZ789\nKCS1A-0825A-05`}
              className="w-full border p-2 rounded font-mono text-sm"
              required
            />
            <p className="text-xs text-gray-500 mt-1">
              Hệ thống sẽ bỏ qua các dòng trống và tự loại bỏ khoảng trắng đầu/cuối.
            </p>
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Hủy
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Tạo mã
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ... (Modal EditWarrantyModal tương tự)
const EditWarrantyModal = ({
  serial,
  onClose,
  onUpdated,
}: {
  serial: any;
  onClose: () => void;
  onUpdated: () => void;
}) => {
  const [newDate, setNewDate] = useState(() => {
    // mặc định hiện ngày hiện tại hoặc ngày hết hạn cũ (nếu có)
    return serial.warrantyExpires
      ? new Date(serial.warrantyExpires).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0];
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = getAuthToken();
      await api.patch(
        `/serials/${serial._id}/warranty`,
        { warrantyExpires: newDate },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      window.alert('✅ Cập nhật bảo hành thành công!');
      onUpdated();
      onClose();
    } catch (error: any) {
      console.error('❌ Lỗi cập nhật bảo hành:', error);
      window.alert(error.response?.data?.message || '❌ Cập nhật thất bại.');
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Cập nhật ngày hết hạn bảo hành
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Ngày hết hạn mới
            </label>
            <input
              type="date"
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
              className="w-full border p-2 rounded"
              required
            />
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Hủy
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Lưu
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};



// --- Component chính ---
const QLQRSanPham = () => {
  const [serials, setSerials] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [editingSerial, setEditingSerial] = useState<any | null>(null);

  const fetchSerials = async () => {
    try {
      const token = getAuthToken(); // ✅ Dùng helper
      const { data } = await api.get('/serials', {
        headers: { Authorization: `Bearer ${token}` },
      });
      // ... (code không đổi)
      const withExpires = (Array.isArray(data) ? data : []).map((s: any) => {
        let warrantyExpires: string | null = s.warrantyExpires || null;
        if (
          !warrantyExpires &&
          s.isActivated &&
          s.activationDate &&
          s.device?.warrantyPeriodInMonths
        ) {
          const d = new Date(s.activationDate);
          d.setMonth(d.getMonth() + s.device.warrantyPeriodInMonths);
          warrantyExpires = d.toISOString();
        }
        return { ...s, warrantyExpires };
      });
      const sortedSerials = withExpires.sort((a, b) => 
        a.serialNumber.localeCompare(b.serialNumber)
      );
      setSerials(sortedSerials);
    } catch (error) {
      console.error('❌ Lỗi khi tải danh sách sê-ri:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteSerial = async (serialId: string) => {
    if (!window.confirm('Bạn có chắc muốn xóa mã này?')) return;
    try {
      const token = getAuthToken(); // ✅ Dùng helper
      await api.delete(`/serials/${serialId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      window.alert('✅ Xóa thành công!');
      fetchSerials();
    } catch (error: any) {
      window.alert(error.response?.data?.message || '❌ Xóa thất bại.');
    }
  };

  useEffect(() => {
    fetchSerials();
  }, []);

  // ... (phần còn lại của component không đổi)
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Quản lý Mã Sê-ri Sản phẩm</h1>

      <div className="mb-6">
        <a
          href="/admin/dashboard"
          className="text-sm text-gray-600 hover:text-blue-600 transition-colors"
        >
          ← Trở về Dashboard
        </a>
      </div>

      <div className="flex justify-end mb-6">
        <button
          onClick={() => setShowGenerateModal(true)}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white font-semibold rounded hover:bg-green-700 transition"
        >
          <PlusCircle size={18} /> Tạo mã sê-ri
        </button>
      </div>

      {isLoading ? (
        <p className="text-gray-600 text-center">Đang tải dữ liệu...</p>
      ) : (
        <div className="overflow-x-auto shadow border rounded-lg">
          <table className="min-w-full border-collapse bg-white text-sm">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="border p-3 text-left">Số sê-ri</th>
                <th className="border p-3 text-left">Thiết bị</th>
                <th className="border p-3 text-left">Tên khách hàng</th>
                <th className="border p-3 text-left">Số điện thoại</th>
                <th className="border p-3 text-center">Kích hoạt</th>
                <th className="border p-3 text-center">Ngày hết hạn</th>
                <th className="border p-3 text-center">Hành động</th>
              </tr>
            </thead>
            <tbody>
              {serials.map((s) => (
                <tr key={s._id} className="hover:bg-gray-50">
                  <td className="border p-3">{s.serialNumber}</td>
                  <td className="border p-3">{s.device?.name_vi}</td>
                  <td className="border p-3">{s.customerName || '-'}</td>
                  <td className="border p-3">{s.customerPhone || '-'}</td>
                  <td className="border p-3 text-center">
                    {s.isActivated ? (
                      <span className="text-green-600 font-semibold">Đã kích hoạt</span>
                    ) : (
                      <span className="text-gray-500">Chưa</span>
                    )}
                  </td>
                  <td className="border p-3 text-center">
                    {s.warrantyExpires
                      ? new Date(s.warrantyExpires).toLocaleDateString('vi-VN')
                      : '-'}
                  </td>
                  <td className="border p-3 text-center">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => setEditingSerial(s)}
                        className="text-blue-600 hover:text-blue-800"
                        title="Sửa bảo hành"
                      >
                        <Edit3 size={18} />
                      </button>
                      <button
                        onClick={() => handleDeleteSerial(s._id)}
                        className="text-red-600 hover:text-red-800"
                        title="Xóa"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showGenerateModal && (
        <GenerateSerialsModal
          onClose={() => setShowGenerateModal(false)}
          onGenerated={fetchSerials}
        />
      )}
      {editingSerial && (
        <EditWarrantyModal
          serial={editingSerial}
          onClose={() => setEditingSerial(null)}
          onUpdated={fetchSerials}
        />
      )}
    </div>
  );
};

export default QLQRSanPham;